import { modals } from '@mantine/modals';

import { useDeleteShopCommissionMutation } from '../store/shop-commissions-api';
import { useShowResponseStatus } from '@/shared';

import { TShopCommission } from '../store/types';

export const useDeleteShopCommission = () => {
  const [deleteShopCommission, { isLoading, isSuccess, isError }] = useDeleteShopCommissionMutation();

  useShowResponseStatus({
    isSuccess,
    successMessage: 'Комиссия магазина успешно удалёна',
    isError,
    errorMassage: 'При удалении коммиссии произошла ошибка',
  });

  const openDeleteModal = (params: TShopCommission) =>
    modals.openConfirmModal({
      title: `Удаление комиссии с ID ${params.id}`,
      centered: true,
      children: `Вы точно хотите удалить комиссию для "${params.shopName}"?`,
      labels: { confirm: 'Удалить', cancel: 'Отмена' },
      confirmProps: { color: 'red' },
      onConfirm: async () => await deleteShopCommission({ commissionId: params.id }),
    });

  return {
    deleteShopCommission,
    openDeleteModal,
    isLoading,
  };
};
